import { faCalendar } from '@fortawesome/pro-solid-svg-icons'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { ShareIcon, ShareText } from '../style'

const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
`

const OptiosLogo = styled.img`
  display: block;
  margin-top: 24px;
  max-width: 90%;
  height: 25px;
`

const TryOptios = styled.a`
  text-align: center;
  margin-top: 16px;
`

const BookingButton = styled(TryOptios)`
  background-color: #fff;
  justify-content: center;
  display: flex;
`

type Props = {
  bookingUrl: string
  referralUrl: string
}

export const PublicFooter: React.FC<Props> = ({ bookingUrl, referralUrl }) => {
  const { t } = useTranslation()

  const optiosLogo =
    'https://images.squarespace-cdn.com/content/v1/61309b7dbcbb7f22b7fe1af3/7ed0568d-edba-4538-9290-bcba5cd87b3c/Logo+Optios.png?format=750w'

  return (
    <FooterWrapper>
      <p>{t('Arrival')}</p>
      <BookingButton
        onClick={() => window.open(bookingUrl, '_blank')}
        className="button-invite-friends">
        <ShareIcon icon={faCalendar} />
        <ShareText>{t('Book an appointment')}</ShareText>
      </BookingButton>

      <TryOptios
        className="button-invite-friends"
        onClick={() => window.open(referralUrl, '_blank')}>
        {t('Try Optios for your salon')}
      </TryOptios>

      <OptiosLogo
        src={optiosLogo}
        onClick={() => window.open('https://www.optios.net/', '_blank')}
      />
    </FooterWrapper>
  )
}
